<template>
    <nav class="main-header navbar navbar-expand navbar-dark navbar-primary">
        <ul class="navbar-nav">
            <li class="nav-item">
                <a class="nav-link" data-widget="pushmenu" href="#" @click.prevent="collapse"><i class="fas fa-bars"></i></a>
            </li>
        </ul>
        <ul class="navbar-nav ml-auto">
            <li class="nav-item">
                <Notificaciones></Notificaciones>
            </li>
        </ul>
    </nav>
</template>

<script>
import Notificaciones from '../notificaciones/Notificaciones';

export default {
    data() {
        return {

        }
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        }
    },
    methods: {
        collapse() {
            this.$emit('collapse');
        }
    },
    components: {
        Notificaciones
    }
}
</script>